import { Link, useLocation } from "wouter";
import { REQUEST_QUOTE_LABEL } from "@shared/pricing";
import { unitSlug } from "@/lib/unit-helpers";
import type { ProjectUnit } from "@shared/schema";

export { REQUEST_QUOTE_LABEL };

/** A lakásoldali érdeklődő-űrlap horgonya (unit-detail sidebar kártyája). */
export const QUOTE_ANCHOR = "ajanlatkeres";

/**
 * Az adott lakás ajánlatkérő űrlapjára mutató link: a lakás SAJÁT oldalára
 * visz, egyenesen az „Érdekel ez a lakás?" űrlaphoz görgetve — így az
 * ajánlatkérés eleve a lakás adataival indul (projekt + lakás előtöltve).
 */
export function unitQuoteHref(projectSlug: string, unit: ProjectUnit): string {
  return `/projektek/${projectSlug}/${unitSlug(unit)}#${QUOTE_ANCHOR}`;
}

const BASE_CLASS =
  "text-accent font-semibold hover:text-accent-700 hover:underline transition-colors cursor-pointer";

/**
 * „Kérjen ajánlatot" — az ár helyén álló, kattintható hívás. Ott használd,
 * ahol NEM vagyunk már egy link belsejében (a beágyazott <a> érvénytelen HTML).
 */
export function RequestQuoteLink({
  href,
  className = "",
}: {
  href: string;
  className?: string;
}) {
  return (
    <Link href={href} className={`${BASE_CLASS} ${className}`}>
      {REQUEST_QUOTE_LABEL}
    </Link>
  );
}

/**
 * Ugyanaz, de egy már kattintható sor (Link) BELSEJÉBEN: span + programozott
 * navigáció, hogy ne legyen egymásba ágyazott <a>, és a sor saját linkje se
 * nyeljen el a kattintást.
 */
export function RequestQuoteInline({
  href,
  className = "",
}: {
  href: string;
  className?: string;
}) {
  const [, navigate] = useLocation();
  const go = (e: { preventDefault: () => void; stopPropagation: () => void }) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(href);
  };
  return (
    <span
      role="link"
      tabIndex={0}
      onClick={go}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") go(e);
      }}
      className={`${BASE_CLASS} ${className}`}
    >
      {REQUEST_QUOTE_LABEL}
    </span>
  );
}
